export const requestConfig = {
  url: 'https://wxapi.yixiang.co',
  // url: '/proxy',
  timeout: 30000
}



// WEBPACK FOOTER //
// ./src/api/index.js